import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterArticle_template} from "./filterArticle_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {filterDropdown_template} from "../../../common/js/vnKnockoutJsTemplates/filterDropdown_template";
import {amCharts_v4_date_line_template} from "./amCharts_v4_date_line_template";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";

declare var ko: any;


export class googleOverviewArticle_template extends vnTemplate {

    public filterDates: filterDate_template;
    public filterBrand: filterDropdown_template;
    public filterInitiatives: multipleSelector_template;
    public filterNetworkCategories: multipleSelector_template;
    public filterIntents: multipleSelector_template;
    public filterContentTypes: multipleSelector_template;
    public filterUsers: filterAutoComplete_template;
    public filterArticle: filterArticle_template;
    public filterPublishedDates: filterDate_template;
    public filterPublishedDatesDisabler: filterDropdown_template;
    public filterSources: multipleSelector_template;
    public chart: amCharts_v4_date_line_template;

    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;

    protected exportGoogleOverviewDataCsv: exportDataCsv;

    readonly dateLevels = [
        {"id": "day", "name": "Day"},
        {"id": "week", "name": "Week"},
        {"id": "month", "name": "Month"},
    ];

    readonly filterPublishedDatesDisablerOptions = [
        {"id": "0", "name": "Disable"},
        {"id": "1", "name": "Enable"},
    ];

    readonly dataViews = [
        {"id": "graph", "name": "Graph"},
        {"id": "table", "name": "Table"},
    ];

    readonly sources = [
        {"id": "search", "name": "Search"},
        {"id": "discover", "name": "Discover"},
        {"id": "googleNews", "name": "Google News"},
    ];



    protected getTemplateHtml(): string {

        return `
            <div class="sub-header w-justify" data-bind="visible: hasGoogleOverviewArticleReportReadPermission()">
            
                ` + this.presetFilter.getHtmlBuild() + `
            
                <div class="w-left">
                    <div class="dropdown select-single">
                        <label class="form-label" for="">Date Level</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: dateLevelSelected"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: dateLevels">
                                    <input type="radio" data-bind="checked : $parent.dateLevelSelected, value: id,  attr: { 'id': 'dateLevel_' + id, 'name' : 'dateLevel_' + id }, event:{ change: $parent.onDateLevelChange}">
                                    <label class="form-label" data-bind="attr: {for : 'dateLevel_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="dropdown select-single">
                        <label class="form-label" for="">Data View</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: dataViewSelected"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: dataViews">
                                    <input type="radio" data-bind="checked : $parent.dataViewSelected, value: id,  attr: { 'id': 'dataView_' + id, 'name' : 'dataView_' + id }, event:{ change: $parent.onDataViewChange}">
                                    <label class="form-label" data-bind="attr: {for : 'dataView_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div data-bind="">
                        ${this.filterSources.getHtmlBuild()}
                    </div>                        
                    
                    <div data-bind="">
                        <label class="form-label" for="" >Brands</label>
                        ${this.filterBrand.getHtmlBuild()}
                    </div>
                    
                    <div data-bind="">
                        ${this.filterDates.getHtmlBuild()}
                    </div>
                    
                    <div data-bind="">
                        ${this.filterInitiatives.getHtmlBuild()}
                    </div>
                    
                    <div data-bind="">
                        ${this.filterNetworkCategories.getHtmlBuild()}
                    </div>
                    
                    <div data-bind="">
                        ${this.filterIntents.getHtmlBuild()}
                    </div>
                    
                    <div data-bind="">
                        ${this.filterContentTypes.getHtmlBuild()}
                    </div>
                    
                    <div data-bind="">
                        ${this.filterUsers.getHtmlBuild()}
                    </div>
                    
                    <div data-bind="">
                        ${this.filterArticle.getHtmlBuild()}
                    </div>
                    
                    <div data-bind=", css: {disabledDiv: !publishedDatePickerEnabled()}">
                        ${this.filterPublishedDates.getHtmlBuild()}
                    </div>
                    
                    <div data-bind="">
                        <label class="form-label" for="" >Published Dates</label>
                        ${this.filterPublishedDatesDisabler.getHtmlBuild()}
                    </div>

                </div>
            
            </div>

            <!-- ko if: hasGoogleOverviewArticleReportReadPermission -->
            ` + this.validationsList.getHtmlBuild() + `
                        
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div data-bind="visible: dataViewSelected() == 'graph'" id="selected-sources"></div>
                    <div data-bind="" id="selected-initiatives"></div>
                    <div data-bind="" id="selected-network-categories"></div>
                    <div data-bind="" id="selected-intent"></div>
                    <div data-bind="" id="selected-contentType"></div>
                </div>   
            </div>

            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 style="text-transform: none" class="section-title solo" data-bind="">Data is based on the following percentage of clicks of top articles, divided by the site total</h2>
                </div>

                <div class="w-right">
                    <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}" >Export</button>
                </div>
            </div>

            <div class="highlight-page" data-bind="css: { loading: isPercentageLoading }">
                <div class="highlight-item highlight-search" data-bind="visible: searchPercentage() != 'N/A'">                 
                    <span class="item-title">Search</span>
                    <strong class="item-value icon i-search2" data-bind="text: searchPercentage() + '%'" ></strong>
                </div>
                <div class="highlight-item highlight-discovery" data-bind="visible: discoverPercentage() != 'N/A'">
                    <span class="item-title">Discover</span>
                    <strong class="item-value icon i-google_discover" data-bind="text: discoverPercentage() + '%'" ></strong>
                </div>
                <div class="highlight-item highlight-news" data-bind="visible: googleNewsPercentage() != 'N/A'">
                    <span class="item-title">Google News</span>
                    <strong class="item-value icon i-google_news" data-bind="text: googleNewsPercentage() + '%'" ></strong>   
                </div>
            </div>
            
            <div id="list-results"   data-bind="visible: dataViewSelected() == 'table'" style="position: relative">
                <div class="w-sticky-col" >
                    <table class="list-results list-sections" >
                        <thead>
                            <!-- ko foreach: headers -->
                                <tr class="list-header-section">
                                <!-- ko foreach: $data -->
                                    <th data-bind="attr: { colspan: $data.cols || 1}, css: $data.class || ''"><span data-bind="text: label"></span></th>
                                 <!-- /ko -->
                                 </tr>
                            <!-- /ko -->
                        </thead>
                        <tbody>
                            <!-- ko foreach: tableData -->
                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                <!-- ko with: $parents[0].headers()[$parents[0].headers().length-1] -->
                                    <!-- ko foreach: $data -->
                                        <td data-bind="attr: {'class': $data.columnClass || ''}, css: {'stick-col' : $index() === 0}"><span class="align-right" data-bind="html: $parents[1][$data.key]"></span></td>
                                    <!-- /ko -->
                                <!-- /ko -->
                                </tr>
                            <!-- /ko -->
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div id="graph-results" data-bind="css: { loading: isChartLoading }, visible: dataViewSelected() == 'graph'">
                <section class="w-graph" >
                    <div class="graph">
                         ` + this.chart.getHtmlBuild() + `
                    </div>
                </section>
            </div>
            <!-- /ko -->
            `;
    }

    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('googleOverviewArticle');

        this.filterBrand = new filterDropdown_template("filterBrand", this.getTemplateViewModel(), this.caller);

        this.filterDates = new filterDate_template("filterDates", this.getTemplateViewModel(), this.caller);


        this.filterInitiatives = new multipleSelector_template("filterInitiatives", this.getTemplateViewModel(), this.caller);
        this.filterInitiatives.setLabel("Mappings");
        this.filterInitiatives.setFilterContainerClass('margin-neg');
        this.filterInitiatives.setTagContainerId('selected-initiatives');
        this.filterInitiatives.setTagContainerCaption('Selected mappings:');

        this.filterNetworkCategories = new multipleSelector_template("filterNetworkCategories", this.getTemplateViewModel(), this.caller);
        this.filterNetworkCategories.setLabel("network categories");
        this.filterNetworkCategories.setTagContainerId('selected-network-categories');
        this.filterNetworkCategories.setTagContainerCaption('Selected network categories:');

        this.filterIntents = new multipleSelector_template("filterIntents", this.getTemplateViewModel(), this.caller);
        this.filterIntents.setLabel("Intents");
        this.filterIntents.setFilterContainerClass('margin-neg');
        this.filterIntents.setTagContainerId('selected-intent');
        this.filterIntents.setTagContainerCaption('Selected intent:');

        this.filterContentTypes = new multipleSelector_template("filterContentTypes", this.getTemplateViewModel(), this.caller);
        this.filterContentTypes.setLabel("content type");
        this.filterContentTypes.setTagContainerId('selected-contentType');
        this.filterContentTypes.setTagContainerCaption('Selected content type:');

        this.filterSources = new multipleSelector_template("filterSources", this.getTemplateViewModel(), this.caller);
        this.filterSources.setLabel("Sources");
        this.filterSources.setTagContainerId('selected-sources');
        this.filterSources.setTagContainerCaption('Selected sources:');

        this.filterUsers = new filterAutoComplete_template("filterUsers", this.getTemplateViewModel(), this.caller);
        this.filterUsers.setIsVisible(1);
        this.filterUsers.setPlaceHolderText("User Search");

        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

        let dateEnd = new Date();
        dateEnd.setDate(dateEnd.getDate()-2);

        let dateStart = new Date();
        dateStart.setDate(dateStart.getDate()-9);

        this.filterPublishedDates = new filterDate_template("filterPublishedDates", this.getTemplateViewModel(), this.caller);
        this.filterPublishedDates.setStartPickerId('startPublishedDate');
        this.filterPublishedDates.setEndPickerId('endPublishedDate');
        this.filterPublishedDates.setDateRange(dateStart, dateEnd);

        this.filterPublishedDatesDisabler = new filterDropdown_template('filterPublishedDatesDisabler', this.getTemplateViewModel(), this.caller);
        this.filterPublishedDatesDisabler.setLabel("Disabler");

        this.chart = new amCharts_v4_date_line_template("chart", this.getTemplateViewModel(), this.caller);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.exportGoogleOverviewDataCsv = new exportDataCsv();

    }

    protected getTemplateName(): string {

        return "googleOverviewArticle_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            headers: ko.observableArray([])
            , tableData: ko.observableArray([])
            , dateLevels: ko.observableArray([])
            , dateLevelSelected: ko.observable("day")
            , dataViews: ko.observableArray([])
            , dataViewSelected: ko.observable("graph")
            , publishedDatePickerEnabled: ko.observable(false)
            , searchPercentage: ko.observable(0)
            , discoverPercentage: ko.observable(0)
            , googleNewsPercentage: ko.observable(0)
            , isPercentageLoading: ko.observable(0)
            , isChartLoading: ko.observable(0)
            , googleOverviewPageCsvData: ko.observableArray([])

            , hasGoogleOverviewArticleReportReadPermission: ko.observable(false)
            , selectedRows: ko.observableArray([])
            , onViewModeChange: function () {
                huit_neuf_this.onViewModeChange();
            }
            , onDateLevelChange: function () {
                huit_neuf_this.onDateLevelChange();
            }
            , onDataViewChange: function (data) {
                huit_neuf_this.onDataViewChange(data);
            }
            , exportData: function() {
                huit_neuf_this.getCsvData(self);
            }
            , onClickRowClick: function(index, data){
                huit_neuf_this.onClickRowClick(index);
                return true;
            }
        };
    }

    public getViewModelForRequest() {

        return {
            brand: this.filterBrand.getTemplateViewModel().selectedOption(),
            dateFilterType: this.getTemplateViewModel().filterDates.selectedFilter(),
            startDate: this.getTemplateViewModel().filterDates.startDate(),
            endDate: this.getTemplateViewModel().filterDates.endDate(),
            startDateRange: this.getTemplateViewModel().filterDates.fromRange(),
            endDateRange: this.getTemplateViewModel().filterDates.toRange(),
            initiatives: this.getTemplateViewModel().filterInitiatives.selectedItems(),
            networkCategories: this.getTemplateViewModel().filterNetworkCategories.selectedItems(),
            intents: this.getTemplateViewModel().filterIntents.selectedItems(),
            contentTypes: this.getTemplateViewModel().filterContentTypes.selectedItems(),
            sources: this.getTemplateViewModel().filterSources.selectedItems(),
            user: this.getTemplateViewModel().filterUsers.idSelectedItem(),
            userName: this.getTemplateViewModel().filterUsers.nameSelectedItem(),
            article: this.getTemplateViewModel().filterArticle.articleObjLite(),
            publishedDateFilterType: this.getTemplateViewModel().filterPublishedDates.selectedFilter(),
            startPublishedDate: this.getTemplateViewModel().filterPublishedDates.startDate(),
            endPublishedDate: this.getTemplateViewModel().filterPublishedDates.endDate(),
            startPublishedDateRange: this.getTemplateViewModel().filterPublishedDates.fromRange(),
            endPublishedDateRange: this.getTemplateViewModel().filterPublishedDates.toRange(),
            enabledPublishedDates: this.getTemplateViewModel().publishedDatePickerEnabled(),
            dateLevel: this.getTemplateViewModel().dateLevelSelected(),
            dataView: this.getTemplateViewModel().dataViewSelected(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);

        return container;
    }

    public buildDatePickerCalendar() {

        this.filterDates.buildCalendar();
        this.filterPublishedDates.buildCalendar();
    }

    public setBrandFilterItems(departments) {

        let brands = [];

        brands.push({id: 'network', name: 'Network'});

        for ( let department of departments){

            for( let brand of department.brands){

                if(brand.segments.length > 0){

                    for(let segment of brand.segments){

                        brands.push(segment);
                    }
                }
                else{

                    brands.push(brand);
                }
            }
        }

        this.filterBrand.setOptions(brands);
        this.filterBrand.setLabel("Brands");
    }

    public setDateLevelsItems() {

        this.getTemplateViewModel().dateLevels(this.dateLevels);
    }

    public setDataViewsItems() {

        this.getTemplateViewModel().dataViews(this.dataViews);
    }

    public setPublishedDatesDisablerItems() {

        this.filterPublishedDatesDisabler.setOptions(this.filterPublishedDatesDisablerOptions);
    }

    public setDefaultDates(maxSearchConsoleDate) {

        let dateEnd = new Date(maxSearchConsoleDate);

        let dateStart = new Date(maxSearchConsoleDate);
        dateStart.setTime(dateStart.getTime() - ((24*60*60*1000) * 28));

        this.filterDates.setDateRange(dateStart, dateEnd);
    }

    private onViewModeChange() {

        this.caller.getListData();
    }

    private onDateLevelChange() {

        this.caller.getListData();
    }

    private onDataViewChange(view) {

        this.caller.getListData();
    }

    public setHeader(data) {

        this.getTemplateViewModel().headers(data);
    }

    public setTableData(data) {

        this.getTemplateViewModel().tableData(data);
    }

    public setHasGoogleOverviewArticleReportReadPermission(permission){

        this.getTemplateViewModel().hasGoogleOverviewArticleReportReadPermission(permission);
    }
    
    public setFilterInitiatives(items){

        for (let item of items){

            item['name'] = item['initiative'];
        }

        this.filterInitiatives.setItems(items);
    }

    public setFilterNetworkCategories(items: Array<{id: number, name: string, networkCategories: Array<any>}>): void{

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.filterNetworkCategories.setMultiSectionItems(groups);
        this.filterNetworkCategories.setLabel('Network Categories');
    }

    public setFilterIntents(filterList: Array<{id: number,name: string}>): void{

        this.filterIntents.setItems(filterList);
    }

    public setFilterSources(): void{

        this.filterSources.setItems(this.sources);
    }

    public setFilterContentTypes(items: Array<{id: number, name: string, 'contentTypes': Array<any>}>): void{

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.filterContentTypes.setMultiSectionItems(groups);
        this.filterContentTypes.setLabel('Content Types');
    }

    public setPublishedDatePickerEnabled(enable: boolean): void {

        this.getTemplateViewModel().publishedDatePickerEnabled(enable);
    }

    public isPublishDatesPickerEnabled(): boolean {

        let disabled = this.filterPublishedDatesDisabler.getTemplateViewModel().selectedOption();
        return (disabled != 0);
    }

    public setFilterUsers(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        this.filterUsers.setItems(items);
    }

    public setFilterArticles(items){

        this.getTemplateViewModel().filterArticle.articles(items);
    }

    public setPercentages(percentage){

        this.getTemplateViewModel().searchPercentage(percentage.searchPercentage);
        this.getTemplateViewModel().discoverPercentage(percentage.discoverPercentage);
        this.getTemplateViewModel().googleNewsPercentage(percentage.googleNewsPercentage);
    }

    private padInteger(number: number, size: number)
    {
        let s = number+"";
        while (s.length < size) s = "0" + s;
        return s;
    }

    public updateGraphData(data) {

        let graphData = [];

        if (this.getTemplateViewModel().dateLevelSelected() == 'day') {

            var date24 = new Date();
            date24.setDate(date24.getDate() - 1);

            var date48 = new Date();
            date48.setDate(date48.getDate() - 2);

            let Date24 = date24.getFullYear() + '-' + this.padInteger((date24.getMonth() + 1), 2) + '-' + this.padInteger(date24.getDate(), 2);
            let Date48 = date48.getFullYear() + '-' + this.padInteger((date48.getMonth() + 1), 2) + '-' + this.padInteger(date48.getDate(), 2);



            // ddd if day view
            for (let dateData of data) {

                if (dateData.date == Date24) {

                    graphData.push({
                        "date": dateData.date,
                        "googleNewsClicksYesterday": dateData.googleNewsClicks,
                        "discoverClicksYesterday": dateData.discoverClicks,
                        "searchClicksYesterday": dateData.searchClicks
                    });
                } else if (dateData.date == Date48) {

                    graphData.push({
                        "date": dateData.date,
                        "googleNewsClicksYesterday": dateData.googleNewsClicks,
                        "discoverClicksYesterday": dateData.discoverClicks,
                        "searchClicksYesterday": dateData.searchClicks
                    });
                    graphData.push(dateData);

                } else {

                    graphData.push(dateData);
                }
            }
        }else {

            graphData = data;
        }




        // set xaxis
        this.chart.setDate("date");

        let yaxis = [];

        this.chart.setDisableClickableLegend(1);
        this.chart.setAutoRotateLabels(1);
        this.chart.setLabelMaxWidth(80);
        this.chart.setEnableXScrollbar(1);


        let graphSources = [];

        let filterSources = this.getTemplateViewModel().filterSources.selectedItems();

        for (let source of filterSources) {

            graphSources.push(source);
        }

        if (filterSources.length == 0) {

            graphSources.push("search");
            graphSources.push("discover");
            graphSources.push("googleNews");
        }

        for (let graphSource of graphSources) {

            if (graphSource == 'googleNews') {

                yaxis.push({
                    field: "googleNewsClicks",
                    name: "Google News",
                    axis: "main",
                    color: "#27caca",
                    opposite: false
                });

                if (this.getTemplateViewModel().dateLevelSelected() == 'day') {

                    yaxis.push({
                        field: "googleNewsClicksYesterday",
                        name: "Google News (Fresh)",
                        axis: "main",
                        color: "#27caca",
                        strokeDasharray: "4,4,4,4",
                        patternFill: true,
                        opposite: false
                    });
                }
            }else if (graphSource == 'discover') {

                yaxis.push({
                    field: "discoverClicks",
                    name: "Discover",
                    axis: "main",
                    color: "#23ba6e",
                    opposite: false
                });

                if (this.getTemplateViewModel().dateLevelSelected() == 'day') {

                    yaxis.push({
                        field: "discoverClicksYesterday",
                        name: "Discover (Fresh)",
                        axis: "main",
                        color: "#23ba6e",
                        strokeDasharray: "4,4,4,4",
                        patternFill: true,
                        opposite: false
                    });
                }
            }else if (graphSource == 'search') {

                yaxis.push({
                    field: "searchClicks",
                    name: "Search",
                    axis: "main",
                    color: "#1886ff",
                    opposite: false
                });

                if (this.getTemplateViewModel().dateLevelSelected() == 'day') {

                    yaxis.push({
                        field: "searchClicksYesterday",
                        name: "Search (Fresh)",
                        axis: "main",
                        color: "#1886ff",
                        strokeDasharray: "4,4,4,4",
                        patternFill: true,
                        opposite: false
                    });
                }
            }
        }

        this.chart.setYaxis(yaxis);

        let chart = this.chart.drawChart(graphData);

        this.customizeChart(chart);

    }

    private customizeChart(chart){

        let dateAxis = chart.xAxes.values[0];
        let series = chart.series.values;

        for (let serie of series){

            serie.stacked = true;
            serie.fillOpacity = 0.5;
        }

        chart.dateFormatter.firstDayOfWeek = new Date(this.getTemplateViewModel().filterDates.startDate()).getDay() + 1;

        if (this.getTemplateViewModel().dateLevelSelected() == 'day'){

            dateAxis.tooltipDateFormat = "EEEE, yyyy-MM-dd";
        }
    }

    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.filterInitiatives, params['initiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterNetworkCategories, params['networkCategories']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterIntents, params['intents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterContentTypes, params['contentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterSources, params['sources']);

        this.presetFilter.setAutocompletePresetFilter(this.filterUsers, params['user'], params['userName']);

        this.filterArticle.setViewModelFromRequest(params['article']);

        this.presetFilter.setDates(this.filterDates, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        this.presetFilter.setDates(this.filterPublishedDates, params['publishedDateFilterType'], params['startPublishedDate'], params['endPublishedDate'], params['startPublishedDateRange'], params['endPublishedDateRange']);

        if(typeof params['brand'] !== 'undefined'){

            this.filterBrand.getTemplateViewModel().selectedOption(params['brand']);
        }

        if(typeof params['dateLevel'] !== 'undefined'){

            this.getTemplateViewModel().dateLevelSelected(params['dateLevel']);
        }

        if(typeof params['dataView'] !== 'undefined'){

            this.getTemplateViewModel().dataViewSelected(params['dataView']);
        }

        if(typeof params['enabledPublishedDates'] !== 'undefined'){

            this.filterPublishedDatesDisabler.setSelectedOption(params['enabledPublishedDates'])
            this.getTemplateViewModel().publishedDatePickerEnabled(params['enabledPublishedDates']);
        }
    }

    public getCsvData(obj): void {
        this.caller.getGoogleOverviewListDataForCSV();
    }

    public setGoogleOverviewPageCsvData(parseData) {
        this.getTemplateViewModel().googleOverviewPageCsvData(parseData);
    }

    public exportGoogleOverviewPageCsv() {
        let fileName = 'google_overview_article_' + this.getTemplateViewModel().filterDates.startDate() + '_' + this.getTemplateViewModel().filterDates.endDate() + '.csv';
        this.exportGoogleOverviewDataCsv.exportToCsv(fileName, this.getTemplateViewModel().googleOverviewPageCsvData() );
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/googleOverviewArticle_template.ts